import { combineReducers } from "redux";
import application from "./application_reducer";
import utm from "./utm_reducer";
import blog from "./blog_posts_reducer";
import appFinish from "./app_finish_reducer";

const entitiesReducer = combineReducers({ application, utm, blog, appFinish });

export default entitiesReducer;
